export var KlevuFilterOrder;
(function (KlevuFilterOrder) {
    /**
     * Sort options based on the number of records each option has in the result
     * set.
     */
    KlevuFilterOrder["Frequency"] = "FREQ";
    /**
     * 'INDEX' will sort the options alphabetically.
     */
    KlevuFilterOrder["Index"] = "INDEX";
})(KlevuFilterOrder || (KlevuFilterOrder = {}));
